import { render } from "./AppointmentHistory.vue?vue&type=template&id=d77c5c52&scoped=true&lang=pug"
import script from "./AppointmentHistory.vue?vue&type=script&lang=js"
export * from "./AppointmentHistory.vue?vue&type=script&lang=js"

import "./AppointmentHistory.vue?vue&type=style&index=0&id=d77c5c52&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d77c5c52"]])

export default __exports__